export default "__VITE_ASSET__c33UvwhS__"